import React from 'react';
import lax from 'lax.js';
import about1 from '../../assets/images/about1.jpg';
import about2 from '../../assets/images/about2.jpg';
import one from '../../assets/images/1.png';
import LaxButton from '../Common/LaxButton';

class About extends React.Component {
    constructor(props) {
        super(props)
        lax.setup()

        this.handleScroll = function(x) {
            lax.update(window.scrollY)
        }

        document.addEventListener('scroll', this.handleScroll, false)

        lax.update(window.scrollY)
    }

    componentWillUnmount() {
        document.removeEventListener('scroll', this.handleScroll, false)
    }

    render(){
        return (
            <section id="about" className="uk-about about-area uk-section">
                <div className="uk-container">
                    <div className="uk-grid uk-grid-match uk-grid-medium uk-child-width-1-2@m uk-child-width-1-1@s">
                        <div className="item">
                            <div className="about-content">
                                <div className="uk-section-title section-title">
                                    <span>About Us</span>
                                    <h2>Engineering Excellence, Powered by AI</h2>
                                    <div className="bar"></div>
                                </div>

                                <div className="about-text">
                                    <div className="icon">
                                        <i className="flaticon-quality"></i>
                                    </div>
                                    <h3>A Trusted Technology Partner</h3>
                                    <p>AznTech is a software development and AI consultancy headquartered in Lahore, Pakistan, serving clients across the globe. We bring together experienced engineers, AI specialists, and product thinkers to deliver solutions that are robust, scalable, and built for the real world.</p>
                                    <p>From early-stage startups to established enterprises, we work as a dedicated extension of your team — delivering custom software, intelligent automation, and cloud-native architectures that give your business a competitive edge.</p>
                                </div>
                            </div>
                        </div>

                        <div className="item">
                            <div className="about-img">
                                <img src={about1} className="about-img1" alt="AznTech team at work" />
                                <img src={about2} className="about-img2" alt="AznTech office" />
                                <img src={one} className="shape-img" alt="shape" />

                                <LaxButton />
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        );
    }
}

export default About;
